
export const fundingProgramFieldsMapSF = {
  direction: 'in',
  Id: 'id',
  Name: 'name',
  Program_overview_form__c: 'overviewForm',
  Full_name__r: {
    key: 'fullName',
    in: program => {
      return program.Full_name__r
        ? {
            name: program.Full_name__r.Name || '',
            translationId: program.Full_name__r.Translation_Id__c || '',
            en: program.Full_name__r.Translated_EN__c || '',
            fr: program.Full_name__r.Translated_FR__c || '',
            'iu-cans': program.Full_name__r.Translated_IU_Cans__c || '',
            'iu-latn': program.Full_name__r.Translated_IU_Latn__c || ''
          }
        : null
    },
    out: res => {
      return {
        Translation_Id__c: res.fullName.translationId || '',
        Translated_EN__c: res.fullName.en || '',
        Translated_FR__c: res.fullName.fr || '',
        Translated_IU_Cans__c: res.fullName['iu-cans'] || '',
        Translated_IU_Latn__c: res.fullName['iu-latn'] || ''
      }
    }
  }
}

export interface FundingProgram {
  id: string
  name?: string
  overviewForm?: string
  fullName?: {
    name: string
    translationId: string
    en: string
    fr: string
    'iu-cans': string
    'iu-latn': string
  } | null
}
